module.exports = __webpack_public_path__ + "static/media/Gin de fresa con chía.1e9bd376.webp";